<template>
  <template v-if="!$store.state.loading && $store.state.metaHeader">
    <div v-if="$store.getters.isChristmasParty && $store.getters.isChristmasSeason">
      <div>
        Showing <strong>{{ metaHeaderParts[0] }}</strong>
        results for <strong>{{ $store.state.eventType }} venues</strong>
        in <strong>{{ $store.getters.selectedDateMonthLong }}</strong>
      </div>
    </div>
    <template v-else>
      <div class="flex justify-between items-center">
        <div>
          <span class="font-semibold" data-test-id="number-of-search-results">
            {{ metaHeaderParts[0] }}
          </span>
          {{ metaHeaderParts[1] }}
        </div>
        <ChevronRight v-if="mobileView" class="w-5 h-5 ml-1 -mr-1" />
      </div>
    </template>
  </template>
  <div
    v-else
    class="spinner-dots"
  >
    <div class="bounce1" />
    <div class="bounce2" />
    <div class="bounce3" />
  </div>
</template>

<script>
import ChevronRight from '@tagvenue/icons/24/line/arrows/chevron-right.svg';

export default {
  name: 'SearchResultsMetaHeader',
  components: {
    ChevronRight,
  },
  props: {
    mobileView: {
      type: Boolean,
      required: false,
    },
  },
  data: () => ({
    metaHeaderParts: [],
  }),
  watch: {
    '$store.state.metaHeader': {
      handler() {
        if (!this.$store.state.metaHeader) {
          this.metaHeaderParts = ['', ''];
          return;
        }
        const [firstPart, ...remainingParts] = this.$store.state.metaHeader.split(' ');
        this.metaHeaderParts = [firstPart, remainingParts.join(' ')];
      },
      deep: true,
      immediate: true,
    },
  },
};
</script>
